import styled from 'styled-components';

import BaseModal, {
  ModalCloseButton,
  StyledButton
} from 'shared/components/presentational/Modal/BaseModal';
import { FONT_WEIGHTS } from 'shared/constants/theme';
import CustomLink from 'shared/components/presentational/CustomLink/CustomLink';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';

export const Commitment = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;

export const Link = styled(CustomLink)`
  font-weight: ${FONT_WEIGHTS.bold};
  color: var(--tertiary-label-default);
  cursor: pointer;

  &:hover {
    color: var(--tertiary-label-hover);
  }

  &:active {
    color: var(--tertiary-label-pressed);
  }
`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
  align-items: flex-start;

  ${mediaQueries.fromTablet`
    align-items: flex-end;
  `};
`;

export const Propal = styled.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing-l) * 2);
  flex: 1;

  ${mediaQueries.fromTablet`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  `}
`;

export const Radio = styled.div`
  color: var(--icons-default);
`;

export const Wrapper = styled.div<{ isSelected?: boolean }>`
  background: var(--surface-full);
  display: flex;
  gap: var(--spacing-s);
  align-items: center;
  border: ${({ isSelected }) =>
    isSelected
      ? '1px solid var(--surface-border-default)'
      : '1px solid var(--surface-full)'};
  border-radius: 2px;
  padding: var(--spacing-xl);

  ${mediaQueries.fromTablet`
    &:hover {
      background: var(--surface-primary);
      border: 1px solid var(--surface-border-light);
    }

    gap: var(--spacing-xl);
  `}
`;

export const Modal = styled(BaseModal)`
  background-color: var(--surface-background);
  max-width: 800px;

  & ${ModalCloseButton} {
    background-color: var(--surface-background);
    margin: var(--spacing-s);
  }
  & ${StyledButton} {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    padding: 0;
  }
`;
